export default __webpack_public_path__ + "static/pdp--callout-1-fc5fc15d41f06968e4b7658e90483bde.jpg";